import component from './ct-switch'

const com = {
  install (Vue) {
    Vue.component('CTSwitch', component)
  }
}
export default com
